import { render, staticRenderFns } from "./DeptEdit.vue?vue&type=template&id=69be7795&"
import script from "./DeptEdit.vue?vue&type=script&lang=js&"
export * from "./DeptEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports